import { LoyaltyProgramCapabilities } from '@rd/types/loyalty-program-capability.type';
import { z } from 'zod';

export const loyaltyProgramCapabilitiesSchema = z.nativeEnum(
  LoyaltyProgramCapabilities,
);

export const loyaltyProgramCapabilitySchema = z.object({
  id: z.string(),
  detailsUrl: z.string().nullable(),
  logoUrl: z.string().nullable(),
  conditionsUrl: z.string().nullable(),
  enrollmentUrl: z.string().nullable(),
  category: loyaltyProgramCapabilitiesSchema,
});

export const loyaltyProgramCapabilityModelSchema = z.object({
  id: z.string(),
  type: z.literal('capability'),
  attributes: loyaltyProgramCapabilitySchema.omit({ id: true }),
});
